export enum FeatureFlags {
  allowFreeFormMultiSelect = 'allowFreeFormMultiSelect',
  allowMultipleSendReminders = 'allowMultipleSendReminders',
  enableEditCommentsFromCard = 'enableEditCommentsFromCard',
  isBetaFeature = 'isBetaFeature',
  scenarioExerciseAtExit = 'scenarioExerciseAtExit',
  asOfCapTables = 'asOfCapTables',
  legalStructureEnabled = 'legalStructureEnabled',
  showAdminManageAccess = 'showAdminManageAccess',
  showAdminManageAccessColumnGridDisplay = 'showAdminManageAccessColumnGridDisplay',
  showAggFuncInKpiConfig = 'showAggFuncInKpiConfig',
  showAgentFeedback = 'showAgentFeedback',
  showAllSecurities = 'showAllSecurities',
  showArgusShadowCompare = 'showArgusShadowCompare',
  showBeneficialOwnership = 'showBeneficialOwnership',
  showCapTableAsOfDate = 'showCapTableAsOfDate',
  showCapTableSummaryGridConfig = 'showCapTableSummaryGridConfig',
  showCommentaryAttachments = 'showCommentaryAttachments',
  showCompanyMappings = 'showCompanyMappings',
  showDataCollectionConfig = 'showDataCollectionConfig',
  showDealDocsInActivityDrawer = 'showDealDocsInActivityDrawer',
  showDocumentHub = 'showDocumentHub',
  showDocumentHubPackaging = 'showDocumentHubPackaging',
  showDocumentPreview = 'showDocumentPreview',
  showDealTab = 'showDealTab',
  showEditTimeSeries = 'showEditTimeSeries',
  showEmailStatuses = 'showEmailStatuses',
  showFieldsManager = 'showFieldsManager',
  showFileKpiConfig = 'showFileKpiConfig',
  showFormattersConfig = 'showFormattersConfig',
  showFormulaFields = 'showFormulaFields',
  showFinancialsGrid2 = 'showFinancialsGrid2',
  showFrostedModules = 'showFrostedModules',
  showFundAdminAccessConfig = 'showFundAdminAccessConfig',
  showFundCapitalAllocation = 'showFundCapitalAllocation',
  showFundReporting = 'showFundReporting',
  showFundReserves = 'showFundReserves',
  showGeneralLedger = 'showGeneralLedger',
  showGlSoiRecon = 'showGlSoiRecon',
  showKpiGridWithHistoricalDataSupport = 'showKpiGridWithHistoricalDataSupport',
  showKpiSourceHierarchy = 'showKpiSourceHierarchy',
  showKpiValueSources = 'showKpiValueSources',
  showListDetailsAsPanel = 'showListDetailsAsPanel',
  showMetricsRecon = 'showMetricsRecon',
  showNewCreateCompanyFormInLists = 'showNewCreateCompanyFormInLists',
  showPeopleReporting = 'showPeopleReporting',
  showRequestCollectedData = 'showRequestCollectedData',
  showRoundCreationConfig = 'showRoundCreationConfig',
  showRoundSource = 'showRoundSource',
  showRoundsByFundView = 'showRoundsByFundView',
  rankSourceValues = 'rankSourceValues',
  showSourcing = 'showSourcing',
  showSecurityView = 'showSecurityView',
  showStockSplitInEquitySell = 'showStockSplitInEquitySell',
  showSummaryV2 = 'showSummaryV2',
  showStockSplitInShareExchange = 'showStockSplitInShareExchange',
  showTearsheetLayoutBuilder = 'showTearsheetLayoutBuilder',
  showWeightedScenarios = 'showWeightedScenarios',
  useColumnFormattersInCompanyDetails = 'useColumnFormattersInCompanyDetails',
  useFeatureEntitlements = 'useFeatureEntitlements',
  useKpiFileUpload3 = 'useKpiFileUpload3',
  useManagedServices = 'useManagedServices',
  useNewViewsP = 'useNewViewsP',
  useShowOwnershipTimeline = 'useShowOwnershipTimeline',
  useStarbreakerCollectionV2 = 'useStarbreakerCollectionV2',
  useTearsheetRendererV2 = 'useTearsheetRendererV2',
  useV2Components = 'useV2Components',
}

export function getFeatureFlagsDefaults() {
  return Object.keys(FeatureFlags).reduce(
    (res, key) => {
      res[key as FeatureFlags] = false;

      return res;
    },
    {} as Record<FeatureFlags, boolean>
  );
}

export type MaggieFeatureFlags = ReturnType<typeof getFeatureFlagsDefaults>;
